import React from 'react'
import { Button } from '@material-ui/core'
import { AuthContainer } from 'containers'
import { PrimaryButton, Modal, Loader, SelectQuery } from 'components'
import { GetQueryResponse } from 'types/saveLoadQuery'
import { useGetQueries, useUpdateLastUsedTime } from 'hooks'

export type LoadQueryButtonProps = {
  onSelect(queryData: {}): void
  reportName: string
}

export const LoadQueryButton = (props: LoadQueryButtonProps) => {
  const { onSelect, reportName } = props
  const { user, selectedSupplier } = AuthContainer.useContainer()

  const [open, setOpen] = React.useState(false)
  const [selectedQuery, setSelectedQuery] = React.useState<GetQueryResponse[number]>()

  const { getQueriesStatus, getQueriesData, getQueriesError } = useGetQueries({
    vendorNumber: selectedSupplier?.oracleId ?? '',
    userId: user?.googleId ?? '',
    reportName: reportName,
  })
  const { mutateUpdateLastUsedTime, resetUpdateLastUsedTime } = useUpdateLastUsedTime()

  const isEnabled = getQueriesStatus === 'success'

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setSelectedQuery(undefined)
    setOpen(false)
    resetUpdateLastUsedTime()
  }

  const handleQuerySelect = (selectedQueryTitle: string) => {
    setSelectedQuery(getQueriesData?.find((item) => item.querytitle === selectedQueryTitle))
  }

  const handleSubmit = () => {
    if (!selectedQuery) {
      return
    }

    mutateUpdateLastUsedTime({
      vendorNumber: selectedSupplier?.oracleId ?? '',
      userId: user?.googleId ?? '',
      queryTitle: selectedQuery.querytitle,
      reportName: reportName,
    })

    onSelect(selectedQuery.query)
    handleClose()
  }

  return (
    <>
      {getQueriesStatus === 'loading' && <Loader />}
      <Button
        className={`text-primary underline normal-case text-lg ${!isEnabled ? 'opacity-50' : ''}`}
        disabled={!isEnabled}
        variant="text"
        onClick={handleOpen}
      >
        Load Saved Query
      </Button>

      {open && (
        <Modal open={open} onClose={handleClose} title="Load Saved Query" testId={`load-query`}>
          <div className="flex flex-col w-full sm:w-72">
            <SelectQuery
              selectedQueryTitle={selectedQuery?.querytitle ?? ''}
              setSelectedQueryTitle={handleQuerySelect}
              options={(getQueriesData || []).map((item) => ({
                text: item.querytitle,
                value: item.querytitle,
              }))}
              status={getQueriesStatus}
              error={getQueriesError}
            />
          </div>
          <div className="flex justify-center flex-row gap-x-7 my-6">
            <PrimaryButton outlined={true} buttonText="Cancel" onClick={() => setOpen(false)} />
            <PrimaryButton outlined={false} buttonText="Ok" onClick={handleSubmit} disabled={!selectedQuery} />
          </div>
        </Modal>
      )}
    </>
  )
}
